import { Flex, Box, VStack, HStack } from "@chakra-ui/react";
import { Button } from "@sgi/gravity/Button";
import { Input } from "@sgi/gravity/Input";
import { Typography } from "@sgi/gravity/Typography";
import Title from "../Common/Title";
import { ChangeEvent, KeyboardEvent, useCallback, useState, useEffect, useRef } from "react";
import { useVerifyEmailProxy } from "../Custom Hooks/useVerifyEmailProxy";
import CancelButton from "../Common/Form/CancelButton";
import { Link } from "@sgi/gravity/Link";

function maskEmail(email:string) {
  const [localPart, domain] = email.split('@');
  const maskedLocalPart = localPart.slice(0, 2) + localPart.slice(2).replace(/./g, '*');
  return `${maskedLocalPart}@${domain}`;
}

export default function VerifyEmail() {
  const [verificationCode, setVerificationCode] = useState('');

  const {
    sendCodeAction, verifyCodeAction, sendNewCodeAction, verificationError, readOnlyEmail
  } = useVerifyEmailProxy({ verificationCode });

  const onVerifyChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.target.value), []);
  const onVerificationCodeKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") verifyCodeAction.act();
  }, [verifyCodeAction]);

  const hasSentCodeRef = useRef(false); 

  useEffect(() => {
    if (!hasSentCodeRef.current) {
      hasSentCodeRef.current = true; 
      sendCodeAction.act();
    }
  }, [sendCodeAction]);

  const handleSendNewCodeAction = useCallback(() => {
    setVerificationCode("");
    sendNewCodeAction.act();
  }, [setVerificationCode, sendNewCodeAction]);

  return (
    <Flex direction="column" maxW={544} padding={38} mx="auto" data-testid="verify-email-page-test">
      <Title text="Verify email address" />
      <Typography>
        Your one-time verification code was sent by <strong>email</strong> to
      </Typography>
      <Typography mb={8} variant="bodyBold">
      {maskEmail(readOnlyEmail)}
      </Typography>
      <Box style={{ zIndex: "200", position: "relative" }}>
        {verifyCodeAction.visible && (
          <>
            <Input
              autoFocus
              my={1}
              label="Verification code"
              name="Verification"
              id="verify-code-field"
              type="text"
              style={{ backgroundColor: "white" }}
              onChange={onVerifyChange}
              onKeyDown={onVerificationCodeKeyDown}
              placeholder="Enter Verification code"
              error={verificationError}
              data-testid="code-input"
              isRequired={true}
              value={verificationCode}
              maxLength={6}
              pattern="\\d{6}"
            />
            <VStack mt={6}>
            <Button
              my={1}
              isFullWidth
              data-testid="verify-code-button-test"
              isDisabled={verifyCodeAction.disabled}
              onClick={verifyCodeAction.act}
            >
              Verify Code
            </Button>
            <CancelButton />
            <HStack textStyle="bodyBold">
              <span>
                Didn't receive the email?
              </span>
              <Link
                href="#"
                data-testid="send-new-code-button-test"
                onClick={sendNewCodeAction.disabled ? undefined : handleSendNewCodeAction}
              >
                Resend Code
              </Link>
            </HStack>
            </VStack>
          </>
        )}
      </Box>
    </Flex>
  );
}
